import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MuseumWalkthroughComponent } from './museum-walkthrough.component';
import { NgxUsefulSwiperModule } from 'ngx-useful-swiper';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxUsefulSwiperModule,
    RouterModule,
    HttpClientModule
  ],
  declarations: [MuseumWalkthroughComponent],
  exports: [MuseumWalkthroughComponent]
})
export class MuseumWalkthroughModule { }
